<template>
  <div class="">
    <AppLoading class="app-loading" />
  </div>
</template>

<script>
import AppLoading from '@/components/app/loading/loading.vue'
import { getUrlQuery } from '@/common/common.js'
export default {
  components: { AppLoading },
  data() {
    return {}
  },
  created() {
    this.getQueData()
  },
  methods: {
    async getQueData() {
      let res = await this.$http
        .postBaseApp('api/v3/WeplusData/getWeplusInfoForNoVip', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          //新人问卷状态 : 0-已过期,1-未领取 2-已领取待使用，3-已使用',
          let queState = res.data.config.general_que_state
          let resultRoute =
            res.data.user_info.result_route || res.data.user_info.test_route
          let queId = this.getQueId(resultRoute)
          switch (queState) {
            case 3:
              this.$router.replace(
                '/newcomer-questionnaire-v2/result?id=' + queId
              )
              break
            case 2:
              this.$router.replace(
                '/newcomer-questionnaire-v2/index?id=' + queId
              )
              break
            default:
              this.receiveQue()
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    /* 领取新人问卷 */
    async receiveQue() {
      let res = await this.$http
        .getBaseApp('/member/AppCamp/receiveComerQue', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.getVipData()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    getVipData() {
      this.$http
        .getBaseApp('api/v3/WeplusData/getWeplusInfoForNoVip', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let queId = this.getQueId(res.data.user_info.test_route)
            this.$router.replace('/newcomer-questionnaire-v2/index?id=' + queId)
          } else {
            this.$toast(res.msg)
          }
        })
    },
    //从跳转链接中获取问卷id
    getQueId(url) {
      let link = getUrlQuery('url', url)
      let id = getUrlQuery('id', decodeURIComponent(link))
      return id
    }
  }
}
</script>
<style lang="scss" scoped>
.app-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
</style>
